module.exports = __webpack_public_path__ + "static/media/deep-pocket.2d857f16.png";